import constants from '../../../../appConstants';
import { MultiSelectFilter, StaticFilter } from '@dataGrid/components/columnFilters';
import { mergeUserConfig } from '@dataGrid/gridUtilities';

class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = 'GridConfiguration';
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration({ userConfig = {}, name } = {}) {
    const defaultConfig = GridConfig.getDefaultConfiguration({name});
    return mergeUserConfig({
      defaultConfig,
      userConfig
    });
  }
  static getPriorityOptions(params) {
    return params.context.priorityOptions;
  }
  static getPriorityValueGetter(params) {
    return  params.data.priority?.split(',')?.filter(Boolean) || [];
  }

  static getDefaultConfiguration({name}) {
    return {
      title: name,
      keyColumn: 'code',
      rowSelection: 'single',
      rowDeselection: true,
      enableFilters: false,
      enableSorting: false,
      defaultColDef: {
        lockPinned: true,
        sortable: true,
        filter: true,
        resizable: true,
      },
      columns: [
        {
          headerName: 'Customer',
          headerTooltip: 'Customer',
          field: 'displayCustomerName',
          minWidth: constants.columnWidth.CUSTOMER,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          tooltipValueGetter: (params) => params.value,
        },
        {
          headerName: 'Customer#',
          headerTooltip: 'Customer Account Number',
          field: 'displayCustomerCode',
          minWidth: constants.columnWidth.CUSTOMER_CODE,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          valueGetter: GridConfig.getCustomerCode,
          tooltipValueGetter: (params) => params.value,
        },
        {
          headerName: 'Route',
          headerTooltip: 'Route',
          field: 'route',
          minWidth: constants.columnWidth.ROUTES,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter
        },
        {
          headerName: 'Address',
          headerTooltip: 'Customer Address',
          field: 'address',
          minWidth: constants.columnWidth.CUSTOMER_ADDRESS,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          valueGetter: GridConfig.getCustomerAddress,
          tooltipValueGetter: (params) => params.value
        },
        {
          headerName: 'City',
          headerTooltip: 'City',
          field: 'city',
          cellClass: 'gridCell-leftAlign',
          minWidth: constants.columnWidth.CITY,
          filter: MultiSelectFilter,
          tooltipField: 'city'
        },
        {
          headerName: 'State',
          headerTooltip: 'State',
          field: 'state',
          cellClass: 'gridCell-leftAlign',
          minWidth: constants.columnWidth.STATE,        
          filter: MultiSelectFilter
        },
        {
          headerName: 'Zip',
          headerTooltip: 'Zip',
          field: 'zip',
          cellClass: 'gridCell-leftAlign',
          minWidth: constants.columnWidth.ZIP_CODE,        
          filter: MultiSelectFilter
        },
        {
          headerName: 'Bill at DT',
          headerTooltip: 'Bill at Destination',
          field: 'billsAtDt',
          width: constants.columnWidth.W_100,
          minWidth: constants.columnWidth.W_100,
          suppressSizeToFit: true,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter
        },
        {
          headerName: 'Ttl Bills',
          headerTooltip: 'Total Bills',
          field: 'totalBills',
          width: constants.columnWidth.TOTAL_BILLS,
          minWidth: constants.columnWidth.TOTAL_BILLS,
          suppressSizeToFit: true,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter
        },
        {
          headerName: 'ILINE',
          headerTooltip: 'ILINE',
          field: 'iLine',
          minWidth: constants.columnWidth.ILINE,        
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter
        },
        {
          headerName: "Priority",
          headerTooltip: "Priority",
          field: "priority",
          minWidth: constants.columnWidth.PRIORITY,
          cellClass: "gridCell-leftAlign",
          filter: StaticFilter,
          filterParams: {
            getStaticOptions: GridConfig.getPriorityOptions,
          },
          valueGetter: GridConfig.getPriorityValueGetter
        }
      ]
    };
  }
}

export default GridConfig;
